import React from 'react';
import './doubleHome.scss';

import Home from '../home';
import { shape, any, string } from 'prop-types';

import { useRESTDataCache } from '@atresmedia/elections_modules_library/dist/dataProvider';
import { ELECTION_SPAIN_GENERAL_EUROPE } from '@atresmedia/elections_modules_library/dist/envs';

import { navigateTo } from '../../utils';
import { PROPERTIES_JSON } from '../../core/constants';

/**
 * Componente que puede renderizar varias paginas de resultados, una para cada comunidad que se indique
 */
const DoubleHome = ({ match, history }) => {
  const {
    communities,
    chartTypes,
    year,
    type,
    electionNumber,
    provinces,
    reload,
    placesIds,
    towns
  } = match.params;
  const config = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  let placeIds = placesIds.trim().split('-');
  let places = communities
    ? communities
        .trim()
        .split('-')
        .filter(e => !!e)
    : [placeIds];

  let charts = chartTypes ? chartTypes.trim().split('-') : [];
  let provs = provinces ? provinces.trim().split('-') : [];
  let townsArr = towns ? towns.trim().split('-') : [];

  /**
   * Devolver el nuevo valor de un parametro que admite valores separados por guion (provincias, municipios)
   * @param {*} val Codigo de la provincia/municipio
   * @param {*} arr Array con los codigos actuales
   * @param {*} index Indice del resultado que solicita el parametro (0 1)
   */
  const getParam = (val, arr, index) => {
    let currentArray = [...arr];
    //Si ya hay algun valor seleccionado simplmente sustituimos/añadimos en el array de valores el correspondiente y hacemos join
    if (currentArray.length > 0) {
      if (currentArray.length > 1 || index === 0) {
        currentArray[index] = val;
      } else {
        currentArray.push(val);
      }
      //Si hay algun elemento añadimos la separacion, sino no
      return currentArray.filter(e => !!e).length > 0
        ? `${currentArray.join('-')}`
        : '';
    }

    //Si no habia ningun valor el parametro sera el valor con un guion delante en el caso de que sea el segundo elemento de resultados
    return index > 0 ? `-${val}` : `${val}-`;
  };

  const getParentsParams = (child, index) => {
    let currPlaces = [...places];
    //Si el abuelo es el codigo de españa significa que se cambia la provincia
    if (child.grandpaId === ELECTION_SPAIN_GENERAL_EUROPE) {
      currPlaces[index] = child.parentId;

      let isBackNavigation = !!townsArr[index];
      let townsIds = townsArr.filter(e => !!e).length;
      let currentTowns =
        townsArr.length > 0
          ? `${
              isBackNavigation && townsIds === 2
                ? '/'
                : !isBackNavigation && townsIds === 1
                ? '/'
                : ''
            }${getParam('', townsArr, index)}`
          : '';
      if (child.ineId || provs.length > 0) {
        const path = getParam(child.ineId, provs, index);
        return `${currPlaces.join('-')}${
          path ? `/${path}` : ''
        }${currentTowns}`;
      } else {
        return `${currPlaces.join('-')}`;
      }
    }

    return `${currPlaces.join('-')}/${getParam(
      child.parentId,
      provs,
      index
    )}/${getParam(child.ineId, townsArr, index)}`;
  };

  const onChange = (index, parent, child, fromMap, excludes) => {
    let params = getParentsParams(child, index);
    navigateTo(
      history,
      reload,
      `/${placesIds}/${reload}/${year}/${type}/${electionNumber}/${chartTypes}/${params}/resultados.html`,
      child,
      places[index],
      excludes,
      config
    );
  };

  return (
    <div className={places.length > 1 ? 'pageDoubleHome' : ''}>
      {places.map((p, i) => (
        <div key={i}>
          <Home
            match={{
              ...match,
              params: {
                ...match.params,
                placeId: p,
                year,
                community: p,
                chartType: charts[i] || charts[0],
                province: provs[i],
                town: townsArr[i]
              }
            }}
            history={history}
            onProvinceChange={onChange.bind(this, i)}
          ></Home>
        </div>
      ))}
    </div>
  );
};

DoubleHome.propTypes = {
  /**Parametros de ruta :   Ids de las comunidades/tipos de graficos... separados por guion '-' */
  match: shape({ placeIds: string, communities: string, chartTypes: string }),
  history: any
};

export default DoubleHome;
